import Resizer from "react-image-file-resizer";
import moment from "moment";

export const amountFormat = (num) => {
  return num?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};

export const formatNumberWithCommas = (number) => {
  if (number === undefined || number === null || isNaN(number)) {
    return "Invalid Number";
  }

  const numberStr = number?.toString(); // Ensure it's a string
  const parts = numberStr?.split(".");

  const integerPartWithCommas = parts[0]?.replace(/\B(?=(\d{3})+(?!\d))/g, ",");

  return parts?.length === 2 ? `${integerPartWithCommas}.${parts[1]}` : integerPartWithCommas;
};


// Example usage:
// const number1 = 1234567; // 1,234,567
// const number2 = 987654321; // 987,654,321
// const number3 = 12345.67; // 12,345.67

export const resizeFile = (file) =>
  new Promise((resolve) => {
    Resizer.imageFileResizer(
      file,
      300,
      300,
      "JPEG",
      100,
      0,
      (uri) => {
        resolve(uri);
      },
      "base64"
    );
  });

export const formatBundles = (bundle) => {
  let fineData = [];
  bundle?.forEach((data) => {
    data?.device_types?.forEach((theData) => {
      theData["duration_months"] = data?.duration_months;
      theData["duration_months"] = data?.duration_months;
      theData["downpayment"] = data?.downpayment;
      theData["loan_id"] = data?.loan_id;
      theData["ref_max_amount"] = data?.ref_max_amount;
      theData["ref_min_amount"] = data?.ref_min_amount;
      theData["bundle_name"] = data?.bundle_name;
      theData["sms_qty"] = data?.sms_qty;
      theData["voice_minutes"] = data?.voice_minutes;
      theData["on_net"] = data?.on_net;
      theData["data_qty"] = data?.data_qty;
      theData["monthly_cost_total"] = data?.monthly_cost_total;
      theData["device_option_id"] = data?.device_option_id;
      theData["bundle_id"] = data?.id;
      fineData.push(theData);
    });
  });

  return fineData;
};

export const formatTzMsisdn = (msisdn) => {
  let phone = msisdn.substring(0, 3) === "255" ? msisdn : `255${msisdn}`;
  return phone;
};

export const dateInWord = (date) => {
  return date ? moment(date).format("lll") : "";
};

export const splitAndCapitalize = (inputString) => {
  const parts = inputString.split("_");
  if (parts.length > 0) {
    const firstPart = parts[0];
    const capitalized = firstPart.charAt(0).toUpperCase() + firstPart.slice(1);
    return capitalized;
  }
  return inputString; // If there's no underscore, return the original string
};

export const formatDate = (dateString) => {
  const months = {
    Jan: "01",
    Feb: "02",
    Mar: "03",
    Apr: "04",
    May: "05",
    Jun: "06",
    Jul: "07",
    Aug: "08",
    Sep: "09",
    Oct: "10",
    Nov: "11",
    Dec: "12",
  };

  const parts = dateString.split("-");
  if (parts.length === 3 && months[parts[1]]) {
    const day = parts[0];
    const month = months[parts[1]];
    const year = parts[2];
    return `${year}-${month}-${day}`;
  } else {
    return null; // Invalid date format
  }
};

export const formatDate2 = (inputDate) => {
  // Create a new Date object from the input date string
  const date = new Date(inputDate);

  // Define arrays for month names and suffixes for day of the month
  const months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];
  const daySuffixes = ["th", "st", "nd", "rd"];

  // Get the day, month, and year
  const day = date.getDate();
  const month = date.getMonth();
  const year = date.getFullYear();

  // Determine the day suffix (e.g., "th", "st", "nd", "rd")
  let daySuffix;
  if (day >= 11 && day <= 13) {
    daySuffix = daySuffixes[0];
  } else {
    daySuffix = daySuffixes[day % 10] || daySuffixes[0];
  }

  // Format the date as "15th, Feb, 2022"
  const formattedDate = `${day}${daySuffix}, ${months[month]}, ${year}`;

  return formattedDate;
};

export const formatDate3 = (dateString) => {
  const months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];

  const [day, month, year] = dateString?.split(" ");

  // Convert month abbreviation to a numerical value (1-indexed)
  const monthNumber = months.indexOf(month) + 1;

  // Pad single-digit day and month values with leading zeros
  const paddedDay = String(day).padStart(2, "0");
  const paddedMonth = String(monthNumber).padStart(2, "0");

  // Format the date in YYYY-MM-DD format
  // const formattedDate = `${year}-${paddedMonth}-${paddedDay}`;
  const formattedDate = `${year}-${paddedMonth}-${paddedDay}`;

  return formattedDate || new Date();
};

export const convertUnderscoreToSpace = (input) => {
  // Split the input string by underscore and join with space
  var result = input?.split("_").join(" ");

  return result;
};

export const encodeBase64String = (value) => {
  return btoa(value); // Encodes the string in Base64
};

export const decodeBase64String = (encodedString) => {
  return atob(encodedString); // Decodes Base64 string
};

export const encodeBase64Number = (value) => {
  return btoa(value.toString()); // Encodes number as Base64 string
};

export const decodeBase64Number = (encodedString) => {
  const base64String = atob(encodedString); // Decode Base64 string
  return parseInt(base64String, 10); // Convert back to number
};

export const formatParticularDateTime = (dateString) => {
  const date = new Date(dateString);
  const options = { day: 'numeric', month: 'long', year: 'numeric' };
  let formattedDate = date.toLocaleDateString('en-US', options);

  let hours = date.getHours();
  let minutes = String(date.getMinutes()).padStart(2, '0');
  let ampm = hours >= 12 ? 'PM' : 'AM';
  hours = hours % 12 || 12;

  return `${formattedDate} by ${hours}:${minutes} ${ampm}`;
}


